import { render, staticRenderFns } from "./MapChart.vue?vue&type=template&id=31661a8f&scoped=true&"
import script from "./MapChart.vue?vue&type=script&lang=ts&"
export * from "./MapChart.vue?vue&type=script&lang=ts&"
import style0 from "./MapChart.vue?vue&type=style&index=0&id=31661a8f&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31661a8f",
  null
  
)

export default component.exports